module.exports = __webpack_public_path__ + "static/img/ABUIABAEGAAgyuzrmAYo2NPw-AEw1Qc4-gQ.e714931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ABUIABAEGAAgyuzrmAYo2NPw-AEw1Qc4-gQ.png
// module id = 9Nge
// module chunks = 1